var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sales product-listing"},_vm._l((_vm.categories),function(item,index){return _c('grid',{key:item.id,attrs:{"categoryIndex":index,"category":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }